import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableCarrierAccepted extends Layout {
    sourceCarrierAvailableOrders: DataSource;
    tableAccepted: Table;
}
